import { TKV2_ORDER_ATTACHMENT_API } from '@aloft/toolkit-shared';

import { useEffect } from 'react';

import { usePutMarketAdjustments } from '../../hooks/api/toolkitComponents.ts';
import { useEdgeTrigger } from '../../hooks/useEdgeTrigger.ts';
import {
  adjustmentSettingsMutationComplete,
  marketAdjustmentsMutationComplete,
} from '../../redux/features/orderSlice.ts';
import { useAppDispatch, useAppSelector } from '../../redux/hooks.ts';
import { DEFAULT_SYNC_DRIVER_DELAY_MS } from './consts.ts';

export function useMarketAdjustmentsSyncDriver(orderID: string) {
  const dispatch = useAppDispatch();
  const { mutate: putMarketAdjustments } = usePutMarketAdjustments();

  const marketAdjustments = useAppSelector((state) => state.order.marketAdjustments);
  const { editRevision = 0, serverRevision = 0 } =
    useAppSelector((state) => state.order.marketAdjustmentsSync) ?? {};

  const onSuccess = () => {
    dispatch(
      marketAdjustmentsMutationComplete({
        status: 'success',
        serverRevision: editRevision,
      }),
    );
  };

  const onError = () => {
    dispatch(
      adjustmentSettingsMutationComplete({
        status: 'error',
      }),
    );
  };

  const mutate = () => {
    putMarketAdjustments(
      {
        pathParams: { orderID },
        body: TKV2_ORDER_ATTACHMENT_API.MARKET_ADJUSTMENTS.PUT.REQUEST.BODY.parse(
          marketAdjustments,
        ),
      },
      { onSuccess, onError },
    );
  };

  const mutationTrigger = useEdgeTrigger({
    condition: editRevision > serverRevision,
    delayMs: DEFAULT_SYNC_DRIVER_DELAY_MS,
    action: mutate,
  });

  useEffect(() => {
    mutationTrigger.restartTimer();
  }, [editRevision, mutationTrigger]);
}
